exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sound-editor-not-supported_container_xaEf- {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    font-size: 1.5em;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "sound-editor-not-supported_container_xaEf-"
};